var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterConfettiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.761,
    height: 103.37,
    viewBox: "0 0 152.761 103.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12563",
    "data-name": "Rectangle 12563",
    width: 10.371,
    height: 24.33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12564",
    "data-name": "Rectangle 12564",
    width: 11.861,
    height: 23.748,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46460",
    "data-name": "Group 46460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46461",
    "data-name": "Group 46461",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46458",
    "data-name": "Group 46458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46462",
    "data-name": "Group 46462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63363",
    "data-name": "Path 63363",
    d: "M1026.015,720.489s5.909,4.964,3.643,9.345a6.594,6.594,0,0,0,.031,6.384l-4.339-1.076a6.257,6.257,0,0,1,1.24-5.105c2-2.631,1.6-6.788-.575-9.548",
    transform: "translate(-877.415 -635.629)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63364",
    "data-name": "Path 63364",
    d: "M840.216,498.737l12.771,36.712a.525.525,0,0,1-.73.642L817.485,518.72Z",
    transform: "translate(-702.855 -449.299)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63365",
    "data-name": "Path 63365",
    d: "M810.255,509.122c2.509,2.853,9.63.693,15.907-4.825s9.332-12.3,6.824-15.158-9.63-.693-15.907,4.825-9.332,12.3-6.824,15.158",
    transform: "translate(-696.044 -440.176)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63366",
    "data-name": "Path 63366",
    d: "M909.433,548.056s.132,8.848-12.835,18.418l5.567,2.781s8.634-8.637,9.006-16.2Z",
    transform: "translate(-769.331 -490.74)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63367",
    "data-name": "Path 63367",
    d: "M972.846,623.943s-.065,5.2-5.8,11.918l4.15,2.073a14.583,14.583,0,0,0,3.321-9.183Z",
    transform: "translate(-828.527 -554.505)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46453",
    "data-name": "Group 46453",
    transform: "translate(137.129 57.678)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46452",
    "data-name": "Group 46452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46451",
    "data-name": "Group 46451",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63368",
    "data-name": "Path 63368",
    d: "M960.744,551.05c2.85,7.172,5.11,14.561,7.874,21.765.585,1.525-1.713,2.631-2.3,1.1-2.765-7.2-5.024-14.592-7.874-21.765-.6-1.52,1.7-2.624,2.3-1.1",
    transform: "translate(-958.341 -550.318)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_63369",
    "data-name": "Path 63369",
    d: "M833.4,498.857s-.81,13.284-23.92,15.706c0,0-1.742,8.739,10.621,3.162,9.273-4.183,15.627-14.555,13.3-18.868",
    transform: "translate(-696.063 -449.399)",
    fill: "#3732f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63370",
    "data-name": "Path 63370",
    d: "M4.761,550.5s-6.241,4.541-4.285,9.069A6.594,6.594,0,0,1,0,565.939l4.4-.771a6.257,6.257,0,0,0-.881-5.179c-1.814-2.764-1.128-6.884,1.239-9.485",
    transform: "translate(0 -462.57)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63371",
    "data-name": "Path 63371",
    d: "M34.743,334.192l-15.3,35.733a.525.525,0,0,0,.684.691l35.9-14.906Z",
    transform: "translate(-16.302 -280.81)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63372",
    "data-name": "Path 63372",
    d: "M133.9,347.452c-2.7,2.672-9.655.02-15.532-5.922s-8.452-12.925-5.752-15.6,9.655-.02,15.532,5.922,8.452,12.925,5.752,15.6",
    transform: "translate(-93.73 -272.997)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63373",
    "data-name": "Path 63373",
    d: "M83.929,382.2s-.749,8.818,11.52,19.267L89.7,403.851s-8.011-9.218-7.856-16.79Z",
    transform: "translate(-68.771 -321.147)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63374",
    "data-name": "Path 63374",
    d: "M52.657,456.06s-.3,5.19,4.954,12.293l-4.284,1.779a14.583,14.583,0,0,1-2.673-9.392Z",
    transform: "translate(-42.55 -383.212)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46456",
    "data-name": "Group 46456",
    transform: "translate(6.148 61.518)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46455",
    "data-name": "Group 46455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46454",
    "data-name": "Group 46454",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63375",
    "data-name": "Path 63375",
    d: "M47.991,385.79c-3.343,6.956-6.112,14.169-9.371,21.163-.69,1.481,1.526,2.744,2.22,1.255,3.26-6.994,6.029-14.207,9.371-21.163.709-1.475-1.508-2.736-2.22-1.255",
    transform: "translate(-38.488 -385.128)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_63376",
    "data-name": "Path 63376",
    d: "M112.145,334.191s-.117,13.308,22.767,17.335c0,0,1.129,8.839-10.816,2.414-8.959-4.819-14.575-15.608-11.951-19.749",
    transform: "translate(-93.687 -280.809)",
    fill: "#23a58d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63377",
    "data-name": "Path 63377",
    d: "M202.144,54.609c-2.925,4.821,1.158,9.684,3.6,13.642a20.928,20.928,0,0,1,2.569,15.371c-.288,1.329,1.813,1.722,2.1.4a22.944,22.944,0,0,0-1.885-15.132c-1.945-3.833-7.259-8.749-4.46-13.362.708-1.167-1.223-2.072-1.925-.915",
    transform: "translate(-169.001 -45.436)",
    fill: "#ffee6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63378",
    "data-name": "Path 63378",
    d: "M171.371,215.249a12.932,12.932,0,0,0-1.871-7.554,20.493,20.493,0,0,0-5.943-5.627c-1.117-.792-2.377.914-1.259,1.706a19.1,19.1,0,0,1,5.239,4.78,10.752,10.752,0,0,1,1.708,6.464c-.075,1.35,2.051,1.587,2.126.232",
    transform: "translate(-136.008 -169.618)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63379",
    "data-name": "Path 63379",
    d: "M126.075,163.174a2.205,2.205,0,0,1-1.133-1.823,1.07,1.07,0,0,0-2.113.333,4.158,4.158,0,0,0,1.987,3.2,1.11,1.11,0,0,0,1.494-.235,1.051,1.051,0,0,0-.235-1.471",
    transform: "translate(-103.206 -134.834)",
    fill: "#00b6e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63380",
    "data-name": "Path 63380",
    d: "M308.314,179.4a3.6,3.6,0,0,1-3.566,1.442l.719,2.361a3.967,3.967,0,0,0,3.653-1.426Z",
    transform: "translate(-256.069 -150.745)",
    fill: "#00b6e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63381",
    "data-name": "Path 63381",
    d: "M322.757,287.5a3.368,3.368,0,0,0-4.029,1.207,2.747,2.747,0,0,1-3.894.681l.159,2.647a3.3,3.3,0,0,0,4.242-1.325,3.149,3.149,0,0,1,3.854-1.143Z",
    transform: "translate(-264.543 -241.369)",
    fill: "#f05b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63382",
    "data-name": "Path 63382",
    d: "M264.919,242.484l-2.7,2.33-.78,4.36,2.677-2.191Z",
    transform: "translate(-219.676 -203.751)",
    fill: "#f05b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63383",
    "data-name": "Path 63383",
    d: "M267.083,281.731a6.339,6.339,0,0,0-3.433,2.708,5.891,5.891,0,0,1-3.665,2.765l-.149,1.579a6.715,6.715,0,0,0,4.629-3.272c1.952-3.042,4.453-2.946,4.453-2.946Z",
    transform: "translate(-218.33 -236.729)",
    fill: "#ffee6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63384",
    "data-name": "Path 63384",
    d: "M196.945,190.017a3.614,3.614,0,0,1,3.832.374l.492-2.419a3.966,3.966,0,0,0-3.9-.429Z",
    transform: "translate(-165.486 -157.3)",
    fill: "#af66a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63385",
    "data-name": "Path 63385",
    d: "M177.12,130.588s2.257,1.733,1.465,4.183l2.843-.678a4.455,4.455,0,0,0-1.44-4.282Z",
    transform: "translate(-148.828 -109.077)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63386",
    "data-name": "Path 63386",
    d: "M270.79,96.032a3.243,3.243,0,0,0-.009,4.144,2.656,2.656,0,0,1-.48,3.865l2.619.614a3.177,3.177,0,0,0-.043-4.379,3.033,3.033,0,0,1,.02-3.961Z",
    transform: "translate(-226.906 -80.693)",
    fill: "#5fbe85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63388",
    "data-name": "Path 63388",
    d: "M317.145,244.289l-3.037.277-2.746,2.62,2.949-.193Z",
    transform: "translate(-261.627 -205.268)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63389",
    "data-name": "Path 63389",
    d: "M372.046,195.7a3.978,3.978,0,0,1-3.945,1.6l.795,2.611a4.388,4.388,0,0,0,4.041-1.577Z",
    transform: "translate(-309.303 -164.443)",
    fill: "#f05b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63390",
    "data-name": "Path 63390",
    d: "M391.032,136.511l-2.7,2.33-.78,4.36,2.677-2.191Z",
    transform: "translate(-325.644 -114.706)",
    fill: "#ffce4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63391",
    "data-name": "Path 63391",
    d: "M437.888,157.05a3.337,3.337,0,0,0-3.272,2.614,2.733,2.733,0,0,1-3.349,2.078l1.162,2.389a3.266,3.266,0,0,0,3.425-2.8,3.12,3.12,0,0,1,3.134-2.49Z",
    transform: "translate(-362.379 -131.963)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63392",
    "data-name": "Path 63392",
    d: "M398.22,232.746c-.693-1.148-2.586-.228-1.887.931a3.482,3.482,0,0,1,.174,3.692,4.659,4.659,0,0,1-3.468,1.956c-.059.006-.12.01-.18.013a5.315,5.315,0,0,0,.191-1.492c-.02-1.617-.591-3.914-2.333-4.508-1.785-.609-3.271.872-3.553,2.488a4.515,4.515,0,0,0,2.463,4.7,3.714,3.714,0,0,1-2.419.774,5.107,5.107,0,0,1-3.539-1.391,5.376,5.376,0,0,1-1.579-3.98c-.034-1.33-2.144-1.479-2.11-.137a7.61,7.61,0,0,0,1.759,5.107,7.076,7.076,0,0,0,4.254,2.373,6.367,6.367,0,0,0,5.8-1.963,5.848,5.848,0,0,0,1.947.015,6.516,6.516,0,0,0,4.786-3.277,5.5,5.5,0,0,0-.311-5.3m-8.989,3.476c.074-.537.531-1.3,1.091-.7a4.057,4.057,0,0,1,.618,2.183,3.179,3.179,0,0,1-.171,1.13,3.268,3.268,0,0,1-1.134-.978,2.523,2.523,0,0,1-.4-1.638",
    transform: "translate(-319.284 -195.126)",
    fill: "#5fbe85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63394",
    "data-name": "Path 63394",
    d: "M191.966,340.75c3.3-4.171,9.035-2.3,13.4-1.54a20.569,20.569,0,0,0,14.592-3.021,1,1,0,0,1,1.075,1.68,22.547,22.547,0,0,1-14.144,3.53c-4.087-.373-10.3-3.288-13.45.7-.8,1.01-2.268-.35-1.477-1.351",
    transform: "translate(-161.112 -282.347)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63395",
    "data-name": "Path 63395",
    d: "M400.106,4.534s1.536-2.351,4.058-1.811l-.929-2.7a4.581,4.581,0,0,0-4.159,1.8Z",
    transform: "translate(-335.33 -0.001)",
    fill: "#00b6e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63397",
    "data-name": "Path 63397",
    d: "M438.316,105.6a2.169,2.169,0,0,1,1.471-1.485,1.025,1.025,0,0,0,.545-1.34,1.061,1.061,0,0,0-1.36-.533,4.09,4.09,0,0,0-2.58,2.6,1.039,1.039,0,0,0,.576,1.325,1.052,1.052,0,0,0,1.347-.571",
    transform: "translate(-366.638 -85.852)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63398",
    "data-name": "Path 63398",
    d: "M514.455,108.619s-1.842,2.223-4.35,1.384l.63,2.856a4.711,4.711,0,0,0,4.451-1.357Z",
    transform: "translate(-428.624 -91.269)",
    fill: "#af66a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63399",
    "data-name": "Path 63399",
    d: "M317.011,46.584s.117,3.246-2.661,4.38l2.708,1.963a5.212,5.212,0,0,0,2.768-4.431Z",
    transform: "translate(-264.137 -39.143)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63400",
    "data-name": "Path 63400",
    d: "M456.1,50.014a4.071,4.071,0,0,1,2.664-3.518l-2.14-1.912a4.5,4.5,0,0,0-2.76,3.552Z",
    transform: "translate(-381.362 -37.463)",
    fill: "#f05b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63401",
    "data-name": "Path 63401",
    d: "M869.858,283.437c3.449,4.462-.062,9.753-2.045,13.96a20.927,20.927,0,0,0-.825,15.562c.436,1.288-1.608,1.915-2.043.63a22.944,22.944,0,0,1,.172-15.248c1.5-4.027,6.23-9.509,2.93-13.778-.835-1.08.982-2.2,1.81-1.125",
    transform: "translate(-741.711 -268.024)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63402",
    "data-name": "Path 63402",
    d: "M750.851,520.49a12.931,12.931,0,0,1,7.752-.692,20.5,20.5,0,0,1,7.256,3.785c1.112.8-.089,2.545-1.2,1.746a19.1,19.1,0,0,0-6.225-3.4,10.752,10.752,0,0,0-6.668.491c-1.252.51-2.169-1.422-.912-1.935",
    transform: "translate(-646.361 -466.738)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63403",
    "data-name": "Path 63403",
    d: "M809.544,382.668a3.6,3.6,0,0,0,2.612,2.824l-1.656,1.829a3.968,3.968,0,0,1-2.7-2.847Z",
    transform: "translate(-694.719 -351.77)",
    fill: "#00b6e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63404",
    "data-name": "Path 63404",
    d: "M825.229,458.417l1.452,3.26-1.152,4.277-1.489-3.123Z",
    transform: "translate(-708.364 -415.419)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63405",
    "data-name": "Path 63405",
    d: "M718.509,557.879a3.613,3.613,0,0,0-3.847-.162l-.151-2.464a3.966,3.966,0,0,1,3.923.118Z",
    transform: "translate(-616.33 -496.391)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63407",
    "data-name": "Path 63407",
    d: "M659.526,502.007a3.243,3.243,0,0,1-4.143.072,2.656,2.656,0,0,0-3.858.539l-.654-2.609a3.177,3.177,0,0,1,4.379-.023,3.033,3.033,0,0,0,3.96-.08Z",
    transform: "translate(-562.856 -449.632)",
    fill: "#5fbe85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63409",
    "data-name": "Path 63409",
    d: "M772.518,432.64l2.629,1.545,1.368,3.541-2.586-1.431Z",
    transform: "translate(-665.071 -393.759)",
    fill: "#5fbe85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63410",
    "data-name": "Path 63410",
    d: "M742.169,369.412a3.977,3.977,0,0,0,2.889,3.124l-1.832,2.023a4.388,4.388,0,0,1-2.984-3.148Z",
    transform: "translate(-637.952 -340.631)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63411",
    "data-name": "Path 63411",
    d: "M756.293,308.81l1.452,3.26-1.152,4.277-1.489-3.123Z",
    transform: "translate(-650.439 -289.709)",
    fill: "#ffce4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63412",
    "data-name": "Path 63412",
    d: "M687.221,300.4a3.337,3.337,0,0,1,1.847,3.759,2.733,2.733,0,0,0,2.144,3.307l-2.07,1.666a3.266,3.266,0,0,1-1.9-3.995,3.121,3.121,0,0,0-1.775-3.588Z",
    transform: "translate(-591.922 -282.639)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63413",
    "data-name": "Path 63413",
    d: "M644.7,396.822a6.517,6.517,0,0,0,2.934,5,5.853,5.853,0,0,0,1.768.816,6.366,6.366,0,0,0,4.415,4.249,7.075,7.075,0,0,0,4.86-.334,7.61,7.61,0,0,0,3.768-3.871c.6-1.2-1.37-1.964-1.967-.775a5.377,5.377,0,0,1-3.125,2.928,5.107,5.107,0,0,1-3.795-.249,3.714,3.714,0,0,1-1.858-1.731,4.516,4.516,0,0,0,4.231-3.2c.433-1.582-.28-3.555-2.154-3.765-1.829-.2-3.324,1.63-4.031,3.084a5.32,5.32,0,0,0-.463,1.431c-.054-.029-.107-.057-.158-.088a4.659,4.659,0,0,1-2.3-3.247,3.483,3.483,0,0,1,1.731-3.266c1.126-.75-.195-2.389-1.31-1.646a5.505,5.505,0,0,0-2.542,4.665m8.129,3.62a3.268,3.268,0,0,1-1.443.4,3.171,3.171,0,0,1,.327-1.095,4.061,4.061,0,0,1,1.49-1.711c.762-.3.852.577.69,1.095a2.524,2.524,0,0,1-1.063,1.31",
    transform: "translate(-557.669 -359.584)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63414",
    "data-name": "Path 63414",
    d: "M809.6,193.353s2.3-1.612,1.677-4.115l2.725.84a4.581,4.581,0,0,1-1.658,4.215Z",
    transform: "translate(-696.229 -189.237)",
    fill: "#00b6e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63415",
    "data-name": "Path 63415",
    d: "M780.156,232c.6-.713,1.34-.986,2.018-.369a5.346,5.346,0,0,1,1.226,3.154c.006.055.011.112.015.169a1.757,1.757,0,0,0-.827-.1,2.748,2.748,0,0,0-2.37,2.446c-.255,1.713.622,3.029,1.521,3.2,1.145.223,2.017-.962,2.471-2.579a5.178,5.178,0,0,1,.531,2.232,7.248,7.248,0,0,1-.608,3.407,2.693,2.693,0,0,1-2.114,1.707c-.728.106-.717,2.1.018,1.993a3.549,3.549,0,0,0,2.724-1.94,9.084,9.084,0,0,0,1.115-4.134,8.569,8.569,0,0,0-1.332-5.352,9.383,9.383,0,0,0-.077-1.833c-.27-1.843-.98-3.566-2.008-4.32a2.028,2.028,0,0,0-2.9.588c-.6.716-.011,2.446.593,1.723m3.076,4.947a3.4,3.4,0,0,1-.487,1.122,1.038,1.038,0,0,1-.881.471.643.643,0,0,1-.43-.987,1.735,1.735,0,0,1,1.17-.7,1.067,1.067,0,0,1,.627.1",
    transform: "translate(-670.78 -222.901)",
    fill: "#af66a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63416",
    "data-name": "Path 63416",
    d: "M727.354,261.1a2.169,2.169,0,0,0-.7-1.97,1.025,1.025,0,0,1,.078-1.445,1.061,1.061,0,0,1,1.457.1,4.089,4.089,0,0,1,1.224,3.455,1.039,1.039,0,0,1-1.086.953,1.052,1.052,0,0,1-.975-1.09",
    transform: "translate(-626.314 -246.544)",
    fill: "#2acbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63417",
    "data-name": "Path 63417",
    d: "M648.083,236.377s.719,2.8,3.346,3.106l-1.787,2.316a4.711,4.711,0,0,1-3.449-3.124Z",
    transform: "translate(-558.925 -228.847)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63418",
    "data-name": "Path 63418",
    d: "M845.486,280.631s-1.489,2.887.541,5.1l-3.286.622a5.212,5.212,0,0,1-.616-5.188Z",
    transform: "translate(-723.181 -266.032)",
    fill: "#5753f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63419",
    "data-name": "Path 63419",
    d: "M716.412,205.2a4.07,4.07,0,0,0-.911-4.317l2.751-.818a4.5,4.5,0,0,1,.983,4.389Z",
    transform: "translate(-617.162 -198.333)",
    fill: "#f05b5b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterConfettiIcon);
export default __webpack_public_path__ + "static/media/register-confetti-icon.407cd8fd006fdd20c16e818e26a1f97e.svg";
export { ForwardRef as ReactComponent };